import type { UseRecaptchaSubmissionProps } from './types';

import { checkIfRecaptchaRequired } from './utils';

export const useRecaptchaSubmission = ({
  onErrorCallback,
  onSuccessCallback,
  recaptchaRef,
}: UseRecaptchaSubmissionProps) => {
  const isRecaptchaRequired = checkIfRecaptchaRequired();

  const onSubmitFormWithRecaptcha = async () => {
    if (!isRecaptchaRequired) {
      return true;
    }

    const token = await recaptchaRef.current?.executeAsync();
    if (!token) {
      recaptchaRef.current?.reset();
      onErrorCallback?.();
      return false;
    } else {
      onSuccessCallback?.(token as string);
      recaptchaRef.current?.reset();
      return true;
    }
  };

  return {
    onSubmitFormWithRecaptcha,
  };
};
